export default __webpack_public_path__ + "static/fluentworlds_banner-ed2766f1ea7dacb4fd3f7adf23f97bfd.png";